/**
 * Loads portal-auth SDK once. Only network call allowed besides verify endpoints (via SDK).
 */
export function loadPortalSdk(url: string): Promise<void> {
  if (window.PortalAuth) return Promise.resolve();

  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = url;
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error(`Failed to load Portal Auth SDK: ${url}`));
    document.head.appendChild(script);
  });
}
